<template>
  <!--begin::Content wrapper-->
  <div dir="rtl" class="modal fade forgetpassword-modal qbank-section" id="show-note-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" @show.modal="hidePaymentModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            قائمة بكل الملاحظات
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img class="icon-img text-center" src="assets/img/notepad.png" alt="" />
          </div>
          <h4 class="mb-3 text-center support-text">
            <div class="mb-2">ملاحظات الإختبار</div>
          </h4>
          <input type="hidden" id="qbankNoteId">

          <div class="notes-container">
            <!-- Loader أثناء التحميل -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">جاري التحميل...</span>
              </div>
              <div class="mt-2">جاري تحميل الملاحظات...</div>
            </div>

            <!-- عرض "لا توجد ملاحظات" -->
            <div v-else-if="qbankNotes.length === 0" class="text-center text-muted py-4">
              لا توجد ملاحظات متاحة حاليًا.
            </div>

            <!-- عرض الملاحظات -->
            <div v-else>
              <div v-for="note in qbankNotes" :key="note.id" class="card note-card mb-3">
                <div class="card-body">
                  <p class="note-content mb-1">{{ note.content }}</p>
                  <small class="text-muted">{{ new Date(note.created_at).toLocaleString() }}</small>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>


import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "Notes",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
      qbankNotes: [], // هنا نضيفها
    };
  },

  mounted() {

  },
  methods: {
    async showNotes() {
      this.isLoading = true; // ✅ ابدأ التحميل
      this.qbankNotes = [];  // إعادة تعيين الملاحظات السابقة

      let qbankNoteId = document.getElementById("qbankNoteId").value;

      try {
        const response = await fetch(
          `${apiUrl}/qbanks/${qbankNoteId}/notes`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.qbankNotes = data.data;
        } else {
          console.error("Failed to fetch notes");
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      } finally {
        this.isLoading = false; // ✅ انتهى التحميل
      }
    }


  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

#academia-code {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}

.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0, 196, 68);
}

.notes-container {
  max-height: 300px;
  overflow-y: auto;
  padding: 5px;
}

.note-card {
  border-right: 2px solid rgb(0, 196, 68);
  border-left: 2px solid rgb(0, 196, 68);
  background-color: #f8f9fa12;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.note-content {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 14px;
}
</style>
